import { CircularProgress, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import AddExistingPolicy from 'src/components/Individual/modals/AddExistingPolicy'
import Modal from 'src/components/common/Modal'
import NoPoliciesView from 'src/components/Individual/MyPoliciesView/Views/NoPoliciesView'
import { useQuery } from '@apollo/client'
import {
  GET_CLIENT_BY_YEARS,
  GET_MASTER_DATA,
  GET_PERSONAL_POLICIES,
} from 'src/services/individualService'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import PolicyDetailsView from 'src/components/Individual/MyPoliciesView/Views/PolicyDetailsView'
import {
  addScroll,
  isCorporateAdmin,
  isCorporateLeader,
  removeScroll,
} from 'src/utils/commonMethods'
import AddPolicyImage from 'src/assets/My_Policies_Images/addPolicyImage.svg'
import {
  CLIENT_TYPE,
  EXPIRY_TYPES,
  POLICY_STATUS_TYPES,
  POLICY_TYPE_ALL,
  SXP_UPLOAD_POLICY_TYPE,
} from 'src/utils/constants/common'
import Grid from '@mui/material/Grid'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { COLORS } from 'src/utils/Themes/colors'
import { useDispatch } from 'react-redux'
import { resetFilters } from 'src/actions'
import ExpiredPolicyToolbar from 'src/components/Individual/PolicyDetails/ExpiredPolicyToolbar'
import { POLICY_CONSTANTS } from 'src/utils/constants/policyConstants'

const MyPolicyDetails = ({ clientId, companyName, clientType, userData }) => {
  const classes = useStyles()
  const [isUploadPolicyOpen, setIsUploadPolicyOpen] = useState(false)
  const [selectedStatusType, setSelectedStatusType] = useState(
    POLICY_STATUS_TYPES?.active
  )
  const dispatch = useDispatch()
  const isAdminView = true

  const [years, setYears] = useState([])

  const [insurance, setInsurances] = useState([])

  const [expiredFilterParams, setExpiredFilterParams] = useState({
    year: '',
    policyType: '',
    subType: '',
  })

  const closeUploadPolicyModal = () => {
    setIsUploadPolicyOpen(false)
  }

  const {
    // loading: clientYearsLoading,
    // error: clientYearsError,
    data: clientYears,
  } = useQuery(GET_CLIENT_BY_YEARS(clientId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const {
    // loading: masterDataLoading,
    // error: masterDataError,
    data: masterData,
  } = useQuery(GET_MASTER_DATA(), {
    errorPolicy: 'all',
  })

  const insuranceTypesData = masterData?.getInsuranceTypeData

  useEffect(() => {
    const minYear = parseInt(
      clientYears &&
        clientYears?.getExpiredPoliciesYearLimit?.data
          ?.expiredPolicyYearLimitMin,
      10
    )
    const maxYear = parseInt(
      clientYears &&
        clientYears?.getExpiredPoliciesYearLimit?.data
          ?.expiredPolicyYearLimitHigh,
      10
    )

    if (minYear && maxYear) {
      const yearRange = Array.from(
        { length: maxYear - minYear + 1 },
        (_, i) => minYear + i
      )?.reverse()
      setYears(yearRange)
      setExpiredFilterParams((prevState) => ({
        ...prevState,
        year: yearRange?.[0],
      }))
    }
  }, [clientYears])

  useEffect(() => {
    if (insuranceTypesData) {
      const filteredInsurances = insuranceTypesData?.filter((item) =>
        item?.category?.includes(CLIENT_TYPE?.INDIVIDUAL)
      )
      setInsurances(filteredInsurances)
    }
  }, [insuranceTypesData])

  const {
    loading: personalPoliciesLoading,
    error: personalPoliciesError,
    data: personalPoliciesData,
    refetch,
  } = useQuery(
    GET_PERSONAL_POLICIES(
      clientId,
      selectedStatusType,
      expiredFilterParams?.year || '',
      expiredFilterParams?.policyType === POLICY_TYPE_ALL
        ? ''
        : expiredFilterParams?.policyType,
      expiredFilterParams?.subType || ''
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )

  useEffect(() => {
    dispatch(resetFilters())
    refetch()
    setExpiredFilterParams((prevState) => ({
      ...prevState,
      year: years?.[0],
      policyType: '',
      subType: '',
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatusType])

  useEffect(() => {
    if (isUploadPolicyOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [isUploadPolicyOpen])

  if (personalPoliciesLoading)
    return (
      <div>
        <CircularProgress />
      </div>
    )

  if (personalPoliciesError)
    return (
      <>
        <GraphQlErrors error={personalPoliciesError} routeValue={'back'} />
      </>
    )

  const policyStatusTypes = (selected) => {
    setSelectedStatusType(selected)
  }

  const isSelected = (selected) => {
    return selectedStatusType === selected
  }

  const getNoPoliciesText = () => {
    switch (selectedStatusType) {
      case POLICY_STATUS_TYPES?.verificationPending:
        return POLICY_CONSTANTS?.NO_VERIFICATION_PENDING_POLICIES
      case POLICY_STATUS_TYPES?.expiring:
        return POLICY_CONSTANTS?.NO_EXPIRING_POLICIES
      case POLICY_STATUS_TYPES?.expired:
        return POLICY_CONSTANTS?.NO_EXPIRED_POLICIES
      default:
        return
    }
  }

  const policyList = personalPoliciesData?.getPersonalPolicies?.policies ?? []

  const getPath = () => {
    const roles = userData?.roles
    return isCorporateLeader(roles) || isCorporateAdmin(roles)
      ? 'dashboard/home'
      : 'dashboard'
  }

  return (
    <>
      {isUploadPolicyOpen ? (
        <Modal
          id='modal'
          bgcolor={'rgb(238, 238, 238)'}
          ordered={isUploadPolicyOpen}
          width={'60%'}
          left={'20%'}
          top={'14%'}
          open={isUploadPolicyOpen}
          modelClosed={closeUploadPolicyModal}
        >
          <AddExistingPolicy
            policyType={SXP_UPLOAD_POLICY_TYPE?.PERSONAL}
            closefunction={closeUploadPolicyModal}
            path={getPath()}
          />
        </Modal>
      ) : null}

      <div>
        <div className={classes.policyDetailViewContainer}>
          <Grid
            container
            spacing={1}
            className={classes.myPoliciesHeader}
            justifyContent='center'
          >
            <Grid item xs={12} justifyContent='center' marginRight='30px'>
              <Grid
                container
                spacing={1}
                className={classes.policyStats}
                alignItems='stretch'
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  xl={2}
                  className={`${classes.statsTextGrid} ${
                    isSelected(POLICY_STATUS_TYPES?.active)
                      ? classes.hightlightButton
                      : null
                  }`}
                >
                  <span
                    id='active'
                    onClick={() => {
                      policyStatusTypes(POLICY_STATUS_TYPES?.active)
                    }}
                    className={classes.statsText}
                  >
                    Active :
                    <span className={classes.statsSubText}>
                      &nbsp;
                      {
                        personalPoliciesData?.getPersonalPolicies
                          ?.activePolicies
                      }
                    </span>
                  </span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                  className={`${classes.statsTextGrid} ${
                    isSelected(POLICY_STATUS_TYPES?.verificationPending)
                      ? classes.hightlightButton
                      : null
                  }`}
                >
                  <span
                    id='verificationPending'
                    onClick={() => {
                      policyStatusTypes(
                        POLICY_STATUS_TYPES?.verificationPending
                      )
                    }}
                    className={classes.statsText}
                  >
                    Verification Pending :
                    <span className={classes.statsSubText}>
                      &nbsp;
                      {
                        personalPoliciesData?.getPersonalPolicies
                          ?.verificationPendingPolicies
                      }
                    </span>
                  </span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  xl={2}
                  className={`${classes.statsTextGrid} ${
                    isSelected(POLICY_STATUS_TYPES?.expiring)
                      ? classes.hightlightButton
                      : null
                  }`}
                >
                  <span
                    id='expiring'
                    onClick={() => {
                      policyStatusTypes(POLICY_STATUS_TYPES?.expiring)
                    }}
                    className={classes.statsText}
                  >
                    Expiring :
                    <span className={classes.statsSubText}>
                      &nbsp;
                      {
                        personalPoliciesData?.getPersonalPolicies
                          ?.expiringPolicies
                      }
                    </span>
                  </span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  xl={2}
                  className={`${classes.statsTextGrid} ${
                    isSelected(POLICY_STATUS_TYPES?.expired)
                      ? classes.hightlightButton
                      : null
                  }`}
                >
                  <span
                    id='expired'
                    onClick={() => {
                      policyStatusTypes(POLICY_STATUS_TYPES?.expired)
                    }}
                    className={classes.statsText}
                  >
                    Expired :
                    <span className={classes.statsSubText}>
                      &nbsp;
                      {
                        personalPoliciesData?.getPersonalPolicies
                          ?.expiredPolicies
                      }
                    </span>
                  </span>
                </Grid>
                <Grid
                  className={classes.statsTextGrid}
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  lg={3}
                  xl={3}
                >
                  <span>
                    Total Premium:&nbsp;
                    {formatToINR(
                      personalPoliciesData?.getPersonalPolicies
                        ?.totalPremiumAmount
                    )}
                  </span>
                </Grid>
              </Grid>
            </Grid>
            {policyList?.length ? (
              <Grid item xs={12} className={classes.buttonGrid}>
                <button
                  id='addPolicyButton'
                  className={classes.addPolicyButton}
                  onClick={() => {
                    setIsUploadPolicyOpen(true)
                  }}
                >
                  <img src={AddPolicyImage} alt='Add Policy'></img>{' '}
                  <span>Add Policy</span>
                </button>
              </Grid>
            ) : null}
            <div className={classes.filterContainer}>
              {selectedStatusType === EXPIRY_TYPES?.EXPIRED && (
                <ExpiredPolicyToolbar
                  years={years}
                  insurance={insurance}
                  refetch={refetch}
                  expiredFilterParams={expiredFilterParams}
                  setExpiredFilterParams={setExpiredFilterParams}
                  expired={
                    personalPoliciesData?.getPersonalPolicies
                      ?.expiredPolicies >= 0
                  }
                />
              )}
            </div>
          </Grid>
        </div>
      </div>

      {policyList?.length ? (
        <div>
          <PolicyDetailsView
            id='policyDetailsView'
            openUploadPolicy={() => {
              setIsUploadPolicyOpen(true)
            }}
            policyList={policyList}
            clientId={clientId}
            companyName={companyName}
            path={getPath()}
            clientType={clientType}
            isCeoView={isAdminView}
          />
        </div>
      ) : (
        <Grid item sm={12} md={12} lg={12}>
          <div className={classes.noPoliciesText}>{getNoPoliciesText()}</div>
          <NoPoliciesView
            id='noPoliciesView'
            openUploadPolicy={() => {
              setIsUploadPolicyOpen(true)
            }}
          />
        </Grid>
      )}
    </>
  )
}

export default MyPolicyDetails

const useStyles = makeStyles({
  modalRoot: {
    maxHeight: '90%',
    width: '80%',
    background: 'rgb(238, 238, 238)',
  },
  addPolicyButton: {
    background: '#ffffff',
    color: '#B92250 !important',
    fontSize: '13px',
    fontWeight: '500',
    padding: '8px 20px',
    alignItems: 'center',
    cursor: 'pointer',
    border: '1px solid #B92250 !important',
    borderRadius: '28px !important',
    display: 'flex',
    gap: '8px',
  },
  policyDetailViewContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
  },
  myPoliciesHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    justifyItems: 'center',
  },
  policyStats: {
    fontSize: '15px',
    fontWeight: '500',
  },
  statsText: {
    cursor: 'pointer',
    textAlign: 'center',
  },
  filterContainer: {
    width: '100%',
    padding: '10px',
  },
  buttonGrid: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center !important',
    marginRight: '-30px !important',
    paddingRight: '10px',
  },
  statsTextGrid: {
    padding: '10px !important',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '@media (max-width: 600px)': {
    statsTextGrid: {
      borderRight: '0px',
      textAlign: 'left !important',
    },
  },

  hightlightButton: {
    backgroundColor: 'rgba(185,34,80, 0.15) !important',
    opacity: '3.5 !important',
    alignItems: 'center !important',
    borderRadius: '10px',
  },
  statsSubText: {
    color: '#B92250',
  },
  noPoliciesText: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '18px',
    fontWeight: '500',
    color: COLORS.DARK_PINK,
    fontFamily: 'salsa',
  },
})
